import React, { useCallback } from 'react'
import { IOpenPanel } from '../../../../../../Interfaces/IPanel'
import { IUbicacionEdit } from '../../../../../../Interfaces/auxiliar/IUbicacion'
import { UseUbicacionEliminar } from './UseUbicacionEliminar'
import { PanelHeaderBasic } from '../../../../../../components/Panel/PanrlHeaderBasic'
import { PanelFooter } from '../../../../../../components/Panel/PanelFooter'
import { IComboBox, IComboBoxOption, Panel } from '@fluentui/react'
import { MessageBarResponse } from '../../../../../../components/MessageBarResponse/MessageBarResponse'
import { ProgressBarLoading } from '../../../../../../components/ProgressBarLoading/ProgressBarLoading'
import { Body1, makeStyles } from "@fluentui/react-components";
import { Warning24Filled } from "@fluentui/react-icons";
import { PanelHeader } from '../../../../../../components/Panel/PanelHeader'
export interface IPanelUbicacionEliminar extends IOpenPanel {
  item: IUbicacionEdit
}

export const PanelUbicacionEliminar = (props: IPanelUbicacionEliminar) => {
  const styles = useStyles();
  const { request, setRequest, deleteUbicacion, loading, reset, mensaje, status, contentShow, loadprogress } = UseUbicacionEliminar(props)

  const obtenerTextoEncabezado = (nivel?: number, descripcion?: string) => {
    switch (nivel) {
      case 1:
        return "Tajo";
      case 2:
        return "Región";
      case 3:
        return "Ubicación";
      default:
        return descripcion === "ubicacion" ? "Ubicación" : "";
    }
  };

  const onRenderHeader = useCallback(
    () => {
      const headerText = obtenerTextoEncabezado(props.item.nivel);
      return (
        <PanelHeader
          textHeader={`Eliminar ${headerText}`}
        />
      );
    },
    [props.item.nivel]

  );

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Eliminar"
          texto2={"Salir"}
          //disableButton={disableForm}
          onClick={deleteUbicacion}
          onDismiss={() => {
            reset()
          }}
        />
      </>
    ),
    [request]
  );
  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={reset}
      onRenderHeader={onRenderHeader}
      isFooterAtBottom
      onRenderFooter={onRenderFooter}
    >
      <div hidden={mensaje == ""}>
        <MessageBarResponse
          objetoResponse={{ codigo: status, mensaje: mensaje }}
          close={true}
        />
      </div>
      <div hidden={!loading}>
        <ProgressBarLoading></ProgressBarLoading>
      </div>
      <div hidden={loading}>
        {!mensaje && (
          <>
            {!loadprogress && (
              <>
                {contentShow && (
                  <>
                    <div className={styles.container}>
                      <div>
                        <Warning24Filled className={styles.warning} />
                      </div>
                      <div>
                        <Body1>
                          Esta Ubicación será eliminada permanentemente, ¿Desea
                          eliminar el Ubicación: {props.item.nombre}?
                        </Body1>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
    </Panel>
  )
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    top: "100%",
    alignItems: "center",
  },

  warning: {
    color: " #eaa300",
    width: "60px",
    height: "60px",
  },
});
